import Vue from "vue";
import helpers from "../tools/helpers";

Vue.prototype.$helpers = helpers;
